import FormCheckbox from '@/shared-components/inputs/components/FormCheckbox';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';
import Text from '@/shared-components/text/components/Text';

import './styles/ArtistDeceased.css';

export default function ArtistDeceased({
  loading,
  formState,
  onDeceasedChange,
  onDeathYearChange,
  toggleDeathUnknown,
}) {
  return (
    <>
      {/* Checkbox “Artist is deceased” */}
      <div className="artist-deceased__check-container">
        <FormCheckbox
          readOnly={loading}
          value={formState.isArtistDeceased}
          onChange={onDeceasedChange}
          className="artist-deceased__checkbox"
        />
        <Text className="artist-deceased__text font-size-small">
          The Artist is deceased
        </Text>
      </div>
      {/* Zona expandible solo si está marcado */}
      <div
        className={`artist-deceased__input-container ${
          formState.isArtistDeceased ? 'expanded' : ''
        }`}
      >
        {/* Año de fallecimiento */}
        <PublicFormInput
          readOnly={loading}
          placeholder="Year of passing"
          element="artist_death"
          autoComplete="off"
          value={formState.artist_death}
          onChange={(e) => {
            const digits = e.target.value.replace(/\D/g, '').slice(0, 4);
            onDeathYearChange(digits);
          }}
          inputProps={{ maxLength: 4 }}
          disabled={formState.isDeathUnknown}
          className={formState.isDeathUnknown ? 'faded' : ''}
        />

        {/* Checkbox “unknown” */}
        <div className="artist-unknown-death__check-container">
          <FormCheckbox
            readOnly={loading}
            value={formState.isDeathUnknown}
            onChange={toggleDeathUnknown}
            className="artist-unknown-death__checkbox"
          />
          <Text className="artist-unknown-death__text font-size-small">
            The year of passing is unknown
          </Text>
        </div>
      </div>
    </>
  );
}
